module.exports = __webpack_public_path__ + "media/images/icons/filled/fast-forward-ba6621446a5c0af060531cb4361a299f.svg";